import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createInvoiceInvoicingProductsSchemas } from 'shared/db/validation/schema/invoiceInvoicingProducts';
import { Validator } from 'shared/db/validation/validator';
import {
    InvoiceInvoicingProductRawRecord,
    InvoiceInvoicingProductUpdateRawRecord,
} from 'shared/types/InvoiceInvoicingProduct';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { InvoiceInvoicingProductsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createInvoiceInvoicingProductsSchemas();

const addValidator = createDBEntityValidator<InvoiceInvoicingProductRawRecord>(
    schemas.add,
);
const updateValidator =
    createDBEntityValidator<InvoiceInvoicingProductUpdateRawRecord>(
        schemas.update,
    );
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-invoice-invoicing-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createInvoiceInvoicingProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const invoiceInvoicingProductsInputValidation: InvoiceInvoicingProductsDBValidation =
    {
        add: createInvoiceInvoicingProductsInputValidation(
            addValidator,
            validationStrategy,
        ),
        update: createInvoiceInvoicingProductsInputValidation(
            updateValidator,
            validationStrategy,
        ),
        delete: createInvoiceInvoicingProductsInputValidation(
            deleteValidator,
            validationStrategy,
        ),
    };
